export default __webpack_public_path__ + "static/media/04.ff6313ee.jpeg";